import {Separator, Sign, Options} from './types';
import groupDigits from './groupDigits';
import round from './round';

const hardFormat = (v: number, options: Options): string => {
  if (v === null) return '';
  if (v === 0) return options.prefix + '0' + options.suffix;
  const value = round(v, options);
  const [int, dig] = value.toString().split(Separator.DOT);
  const signed = int.startsWith(Sign.MINUS);
  const unsignedInt = int.replace(Sign.MINUS, '');
  let formatted = options.prefix;
  if (signed) formatted += Sign.MINUS;
  if (options.separateGroups) {
    formatted += groupDigits(unsignedInt.split(''), options).join('');
  } else {
    formatted += unsignedInt;
  }
  if (options.alwaysShowDecimals || dig !== undefined) {
    formatted += options.radix;
    formatted += (dig ?? '').padEnd(options.decimals, '0');
  }
  formatted += options.suffix;
  return formatted;
}

export default hardFormat;
